<template>
  <div class="loading-screen">
    <div class="stage">
      <div class="icon-stack">
        <div class="ring-wrap">
          <svg viewBox="0 0 190 190">
            <circle class="ring-track" cx="95" cy="95" r="83" />
            <circle class="ring-progress" :class="{ drawing: phase === 'success' }" cx="95" cy="95" r="83" />
          </svg>
        </div>

        <svg class="icon-pulse" viewBox="5860.39 2775.85 9264.96 9264.96">
          <g class="icon-pulse-inner" :class="{ pulsing: phase === 'loading' }">
            <!-- Path real da marca (src/assets/logo_avance_icone.svg) — o
                 quadrado arredondado e o vão do "A" são UM único path com
                 fill-rule evenodd; não é uma reconstrução aproximada. -->
            <path
              class="letter-a"
              :class="{ hide: phase === 'success' }"
              fill-rule="evenodd"
              d="M9012.46 11890.81l2960.82 0c1651.15,0 3002.07,-1350.92 3002.07,-3002.07l0 -2960.82c0,-1651.15 -1350.92,-3002.07 -3002.07,-3002.07l-2960.82 0c-1651.15,0 -3002.07,1350.92 -3002.07,3002.07l0 2960.82c0,1651.15 1350.92,3002.07 3002.07,3002.07zm1389.71 -7208.54c-314.71,31.31 -509.96,164.66 -657.02,324.29 -187.09,203.2 -870.31,1599.94 -1042.31,1917.63l-1013.41 1933.48c-147.29,272.34 -211.15,483.41 22.07,704.38 234.5,222.17 458.15,105.81 720.08,-2.28l1400.78 -572.67c115.18,-45.98 263.5,-75.9 256.25,-231.54 -9.91,-211.72 -459.72,-240.04 -604.74,-366.15 -119.28,-103.78 -48.86,-220.79 10.73,-339.53l640.89 -1333.53c55.35,-114.99 107.46,-216.92 160.85,-332.49 48.52,-104.96 110.86,-258.85 268.73,-183.22 80.74,38.66 135.57,206.29 180.81,300.32l482.05 997.44c102.81,216.76 224.82,447.6 319.8,668.06 70.24,163.01 -43.14,234.74 -160.71,282.2 -117.75,47.53 -227.28,93.65 -350.31,142.78 -202.5,80.85 -142.78,253.6 -84.34,302.93 64.52,54.47 1548.83,641.98 1743.8,723.17 296.99,123.65 544.59,59.78 673.65,-172.95 155.6,-280.56 -36.58,-504.44 -140.87,-719.96l-340.05 -647.09c-459.3,-844.66 -893.27,-1733.8 -1352.84,-2579.99 -151.7,-279.37 -191.28,-407.41 -397.86,-589.46 -166.39,-146.68 -444.95,-254.72 -736.03,-225.82z"
            />

            <!-- Fundo sólido (mesmo contorno) só na fase de sucesso, atrás
                 do check — evita retângulo fantasma no loading (opacity:0
                 ainda podia vazar composição em alguns browsers). -->
            <rect
              v-if="phase === 'success'"
              class="success-backdrop"
              x="5860.39" y="2775.85" width="9264.96" height="9264.96" rx="2131"
            />

            <g class="check-group" :class="{ show: phase === 'success' }">
              <path
                class="check-path"
                fill="none"
                d="M8732,7593 L9937,8797 L12345,6204"
              />
            </g>
          </g>
        </svg>
      </div>

      <svg
        class="wordmark"
        :class="{ pulsing: phase === 'loading' }"
        viewBox="3046 8538 14883 2696"
        aria-label="avance"
      >
        <path d="M6491.56 11001.1c-6.06,-14.51 778.02,-2058.65 852.13,-2270.3l686.75 0 -944.82 2274.58 -594.06 -4.28z" />
        <path d="M4561.75 11048.41c-153.34,-17.93 -295.72,-67.89 -427.12,-149.88 -168.19,-104.94 -301.88,-245.82 -401.07,-422.63 -188.27,-335.61 -180.98,-844.98 7.28,-1173.82 102.07,-178.25 243.66,-320.57 424.79,-426.95 181.13,-106.37 386.7,-159.56 616.71,-159.56 232.88,0 431.88,66.6 618.86,159.56 498.84,248.02 1050.84,1018.36 1384.46,1524.63l-294.01 601.39c-129.06,-406.45 -842.99,-1378.5 -1385.87,-1666.72 -96.5,-51.23 -199.81,-88.41 -323.44,-88.41 -123.63,0 -231.45,29.47 -323.45,88.41 -92,58.94 -163.16,137.28 -213.47,235.03 -50.32,97.76 -75.47,205.57 -75.47,323.45 0,47.23 4.24,93.01 12.73,137.34 12.81,58.51 33.44,115.05 61.92,169.64 51.75,99.19 124.35,178.97 217.79,239.35 93.44,60.38 201.97,90.56 325.6,90.56 129.38,0 240.79,-29.47 334.23,-88.4 93.44,-58.94 166.04,-137.29 217.79,-235.04 40.39,-76.28 65.01,-157.83 73.88,-244.62l568.7 568.7 0 469.44 -564.95 0 0 -366.57c-60.38,126.5 -145.91,228.57 -256.6,306.19 -156.91,110.03 -411.38,139.92 -599.29,108.91z" />
        <path d="M8978.52 11076.26c-204.38,0 -390.77,-52.53 -559.17,-157.6 -168.4,-105.07 -302.25,-246.12 -401.56,-423.16 -99.32,-177.03 -148.97,-373.5 -148.97,-589.39 0,-161.2 28.78,-313.05 86.36,-455.54 57.57,-142.49 136.73,-267.71 237.48,-375.66 100.75,-107.95 218.06,-192.87 351.91,-254.76 133.86,-61.89 278.51,-92.83 433.95,-92.83 195.75,0 348.31,36.7 457.7,110.11 109.39,73.4 194.31,170.55 254.76,291.46l0 -354.07 578.6 0 0 2245.31 -565.65 0 0 -367.02c-60.45,126.66 -146.09,228.85 -256.92,306.57 -110.82,77.72 -266.99,116.58 -468.49,116.58zm95 -526.78c129.53,0 241.08,-29.51 334.63,-88.52 93.56,-59.01 166.24,-137.45 218.06,-235.33 51.81,-97.87 77.72,-204.38 77.72,-319.52 0,-118.02 -25.91,-225.97 -77.72,-323.84 -51.82,-97.88 -124.5,-177.04 -218.06,-237.49 -93.55,-60.45 -205.1,-90.68 -334.63,-90.68 -123.78,0 -232.45,29.51 -326.01,88.52 -93.55,59.01 -166.24,137.46 -218.05,235.33 -51.82,97.87 -77.72,205.82 -77.72,323.84 0,112.27 25.9,218.06 77.72,317.37 51.81,99.31 124.5,179.19 218.05,239.64 93.56,60.45 202.23,90.68 326.01,90.68zm1541.49 470.65l0 -2245.31 574.28 0 0 328.16c118.02,-253.32 346.87,-379.98 686.55,-379.98 161.2,0 306.57,37.42 436.11,112.27 129.53,74.84 231.72,181.35 306.57,319.52 74.84,138.18 112.26,302.26 112.26,492.24l0 1373.1 -582.92 0 0 -1230.6c0,-195.75 -44.61,-337.52 -133.85,-425.32 -89.24,-87.8 -205.82,-131.69 -349.75,-131.69 -123.78,0 -232.45,43.89 -326,131.69 -93.56,87.8 -140.34,229.57 -140.34,425.32l0 1230.6 -582.91 0zm3510.46 56.13c-161.2,0 -311.61,-30.22 -451.22,-90.67 -139.62,-60.45 -262.68,-144.65 -369.18,-252.6 -106.51,-107.95 -189.27,-233.17 -248.28,-375.66 -59.02,-142.49 -88.52,-295.78 -88.52,-459.86 0,-218.77 51.09,-416.67 153.28,-593.71 102.19,-177.03 243.25,-318.8 423.16,-425.31 179.91,-106.51 383.57,-159.77 610.98,-159.77 204.38,-2.87 387.18,33.11 548.38,107.95 161.2,74.85 289.3,178.48 384.29,310.89l-449.06 367.02c-51.82,-77.72 -118.74,-139.61 -200.78,-185.67 -82.04,-46.05 -173.44,-69.08 -274.19,-69.08 -123.78,0 -231.73,29.5 -323.84,88.51 -92.12,59.02 -163.36,137.46 -213.74,235.33 -50.38,97.87 -75.56,205.82 -75.56,323.84 0,115.15 26.62,222.38 79.88,321.69 53.25,99.31 126.66,178.47 220.21,237.48 93.56,59.01 202.22,88.52 326,88.52 112.27,0 207.26,-25.19 284.99,-75.56 77.72,-50.38 145.36,-114.43 202.94,-192.15l423.15 367.02c-106.51,135.3 -238.2,241.09 -395.09,317.37 -156.88,76.28 -346.15,114.42 -567.8,114.42zm2124.41 0c-230.29,0 -433.23,-53.25 -608.83,-159.76 -175.59,-106.51 -311.61,-248.28 -408.04,-425.31 -96.44,-177.04 -144.65,-373.5 -144.65,-589.4 0,-215.89 50.37,-413.8 151.13,-593.71 100.75,-179.91 238.2,-323.12 412.36,-429.63 174.15,-106.51 373.49,-159.77 598.03,-159.77 224.53,0 422.43,53.26 593.71,159.77 171.28,106.51 305.13,249.72 401.56,429.63 96.44,179.91 144.65,377.82 144.65,593.71 0,31.67 -1.44,64.77 -4.31,99.31 -2.88,34.55 -7.2,70.53 -12.96,107.95l-1679.66 0c31.66,132.42 95.71,240.36 192.14,323.84 96.44,83.48 218.06,125.22 364.87,125.22 126.65,0 236.76,-28.78 330.32,-86.35 93.55,-57.58 166.24,-129.54 218.05,-215.9l453.38 341.11c-89.24,141.06 -223.09,256.2 -401.56,345.44 -178.48,89.23 -378.54,133.85 -600.19,133.85zm-8.64 -1856.7c-138.17,0 -256.2,41.74 -354.07,125.22 -97.87,83.48 -162.64,192.87 -194.3,328.16l1109.7 0c-31.67,-123.78 -97.15,-230.29 -196.47,-319.52 -99.31,-89.24 -220.93,-133.86 -364.86,-133.86z" />
      </svg>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

// `done` reflete authStore.isInitialized — o componente não faz nenhuma
// suposição sobre QUANTO TEMPO a verificação de sessão leva (pode ser
// 100ms ou 2s dependendo da rede); ele só reage quando o valor vira true.
const props = defineProps({
  done: { type: Boolean, default: false },
})
const emit = defineEmits(['finished'])

const phase = ref('loading') // 'loading' -> 'success'
const startedAt = Date.now()

// Sequência curta (anel + check) só quando o validate foi rápido — se a
// sessão já demorou, somar mais ~3s de animação deixava o splash preso.
// Timings abaixo precisam bater com as durations/delays do <style>.
const SUCCESS_SEQUENCE_MS = 550
const SKIP_SUCCESS_AFTER_MS = 800

watch(
  () => props.done,
  (isDone) => {
    if (isDone && phase.value === 'loading') {
      if (Date.now() - startedAt >= SKIP_SUCCESS_AFTER_MS) {
        emit('finished')
        return
      }
      phase.value = 'success'
      setTimeout(() => emit('finished'), SUCCESS_SEQUENCE_MS)
    }
  },
  { immediate: true }
)
</script>

<style scoped>
.loading-screen {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: hsl(var(--background));
}

.stage {
  /* Mesma escala visual do logo_avance_completa no Login mobile (h-20):
     ícone ~38px, wordmark ~170px, gap ~10px — ratio texto/ícone ~4.5×. */
  --logo-mark-height: 5rem;
  --logo-brand-color: #ff4d18;
  --logo-icon-size: calc(var(--logo-mark-height) * 0.475);
  --logo-wordmark-width: calc(var(--logo-icon-size) * 4.5);
  --logo-ring-size: calc(var(--logo-icon-size) * 1.42);
  --logo-stack-size: var(--logo-ring-size);

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(var(--logo-mark-height) * 0.125);
  opacity: 0;
  transform: translateY(14px) scale(0.92);
  animation: entrance 0.7s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
}
@keyframes entrance {
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.icon-stack {
  position: relative;
  width: var(--logo-stack-size);
  height: var(--logo-stack-size);
  display: flex;
  align-items: center;
  justify-content: center;
}

.ring-wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  width: var(--logo-ring-size);
  height: var(--logo-ring-size);
  margin-top: calc(var(--logo-ring-size) / -2);
  margin-left: calc(var(--logo-ring-size) / -2);
  pointer-events: none;
}
.ring-wrap svg { width: 100%; height: 100%; transform: rotate(-90deg); }
.ring-track {
  fill: none;
  stroke: hsl(var(--foreground) / 0.06);
  stroke-width: 3;
}
.ring-progress {
  fill: none;
  stroke: #ffb04d;
  stroke-width: 3;
  stroke-linecap: round;
  stroke-dasharray: 522; /* 2*pi*r, r=83 */
  stroke-dashoffset: 522;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.ring-progress.drawing {
  opacity: 1;
  transition: opacity 0.15s ease, stroke-dashoffset 0.4s cubic-bezier(0.4, 0, 0.2, 1) 0.05s;
  stroke-dashoffset: 0;
}

.icon-pulse {
  position: absolute;
  top: 50%;
  left: 50%;
  width: var(--logo-icon-size);
  height: var(--logo-icon-size);
  margin-top: calc(var(--logo-icon-size) / -2);
  margin-left: calc(var(--logo-icon-size) / -2);
  overflow: visible;
  background: transparent;
  border: none;
  outline: none;
}

.icon-pulse-inner {
  transform: scale(1);
  transform-box: fill-box;
  transform-origin: center;
}
.icon-pulse-inner.pulsing {
  animation: pulse 1.5s ease-in-out infinite;
}
@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.06); }
}

.letter-a {
  fill: var(--logo-brand-color);
  transition: opacity 0.2s ease 0.3s;
}
.letter-a.hide {
  opacity: 0;
}

.success-backdrop {
  fill: var(--logo-brand-color);
  opacity: 0;
  animation: success-backdrop-in 0.2s ease 0.28s forwards;
}
@keyframes success-backdrop-in {
  to { opacity: 1; }
}

.check-group {
  opacity: 0;
  transition: opacity 0.15s ease 0.32s;
}
.check-group.show {
  opacity: 1;
}
.check-path {
  stroke: #fdf6ef;
  stroke-width: 620;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 5245;
  stroke-dashoffset: 5245;
  transition: stroke-dashoffset 0.2s cubic-bezier(0.2, 0.8, 0.2, 1) 0.35s;
}
.check-group.show .check-path {
  stroke-dashoffset: 0;
}

.wordmark {
  width: var(--logo-wordmark-width);
  height: auto;
  fill: var(--logo-brand-color);
  transform: scale(1);
  transform-origin: center;
}
.wordmark.pulsing {
  animation: pulse 1.5s ease-in-out infinite;
}
</style>
